import { STORAGE_KEY_PENDING_REDIRECT } from 'constants/StorageKeys'
import {
  getSafeRedirectUrl,
  isSafePath
} from 'core/hooks/auth/getSafeRedirectUrl'

// Persist a safe `redirect_url` so it survives the SSO round trip off-origin
export const stashPendingRedirect = (search: string): void => {
  const safe = getSafeRedirectUrl(search)
  if (!safe) return
  try {
    sessionStorage.setItem(STORAGE_KEY_PENDING_REDIRECT, safe)
  } catch {
    console.error('[pendingRedirect] sessionStorage unavailable')
  }
}

// Read-and-clear; the stored value is re-validated since storage is attacker-writable
export const takePendingRedirect = (): string | null => {
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY_PENDING_REDIRECT)
    sessionStorage.removeItem(STORAGE_KEY_PENDING_REDIRECT)
    return stored && isSafePath(stored) ? stored : null
  } catch {
    console.error('[pendingRedirect] sessionStorage unavailable')
    return null
  }
}
